import React, { useState, useEffect } from 'react';
import { Cookie, X } from 'lucide-react';

const CookieBanner = () => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const consent = localStorage.getItem('cookieConsent');
    if (!consent) {
      setIsVisible(true);
    }
  }, []);

  const handleAcceptAll = () => {
    localStorage.setItem('cookieConsent', 'all');
    setIsVisible(false);
  };

  const handleAcceptEssential = () => {
    localStorage.setItem('cookieConsent', 'essential');
    setIsVisible(false);
  };

  if (!isVisible) return null;

  return (
    <div style={{
      position: 'fixed', bottom: '20px', left: '20px', right: '20px', zIndex: 9999,
      display: 'flex', justifyContent: 'center'
    }}>
      <div className="glass-panel" style={{
        maxWidth: '600px', width: '100%', padding: '1.5rem', 
        display: 'flex', flexDirection: 'column', gap: '1rem',
        boxShadow: '0 10px 40px rgba(0,0,0,0.5)', border: '1px solid var(--glass-border)'
      }}>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start' }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: '0.8rem' }}>
            <div style={{ background: 'var(--strava-orange)', color: 'white', padding: '0.5rem', borderRadius: '50%' }}>
              <Cookie size={20} />
            </div>
            <h3 style={{ margin: 0, fontSize: '1.1rem' }}>Valoramos tu privacidad</h3>
          </div>
          <button onClick={handleAcceptEssential} style={{ background: 'none', border: 'none', color: 'var(--text-muted)', cursor: 'pointer' }}>
            <X size={20} />
          </button>
        </div>
        
        <p style={{ margin: 0, fontSize: '0.9rem', color: 'var(--text-secondary)', lineHeight: 1.5 }}>
          Utilizamos cookies y tecnologías similares (como localStorage) propias y de terceros para autenticarte, 
          recordar tus preferencias y analizar el tráfico de la plataforma. Puedes aceptar todas las cookies o solo 
          las esenciales para el funcionamiento básico.
        </p>

        <div style={{ display: 'flex', gap: '1rem', marginTop: '0.5rem', flexWrap: 'wrap' }}>
          <button onClick={handleAcceptAll} style={{
            flex: 1, padding: '0.8rem', background: 'var(--strava-orange)', color: 'white', 
            border: 'none', borderRadius: '8px', fontWeight: 'bold', cursor: 'pointer', transition: 'filter 0.2s'
          }} onMouseOver={e => e.target.style.filter = 'brightness(1.1)'} onMouseOut={e => e.target.style.filter = 'brightness(1)'}>
            Aceptar Todo
          </button>
          <button onClick={handleAcceptEssential} style={{
            flex: 1, padding: '0.8rem', background: 'rgba(255,255,255,0.05)', color: 'white', 
            border: '1px solid var(--glass-border)', borderRadius: '8px', fontWeight: 'bold', cursor: 'pointer', transition: 'background 0.2s'
          }} onMouseOver={e => e.target.style.background = 'rgba(255,255,255,0.1)'} onMouseOut={e => e.target.style.background = 'rgba(255,255,255,0.05)'}>
            Solo Esenciales
          </button>
        </div>
      </div>
    </div>
  );
};

export default CookieBanner;
